import React from 'react';
import { ModuleProps } from 'types';
import { useLocation } from 'react-router-dom';
import { parseQueryParams } from 'utilities/query-params-util';

const ReportsContainer: React.FC<ModuleProps> = () => {
  const location = useLocation();
  const params = parseQueryParams(location.search);

  /* example chart loading */
  // const [{ registered }, { onElementLoaded, registerElements }] = usePageContentLoading();

  // const handleOnLoad = (id) => (): void => {
  //   onElementLoaded(String(id));
  // };

  // useEffect(() => {
  //   if (!registered && data) {
  //     registerElements(graphIds);
  //   }
  // }, [data, graphIds, registerElements, registered]);

  return <div>Reports Container widges in here; ; params: {JSON.stringify(params)}</div>;
};

export default ReportsContainer;
